module.exports = __webpack_public_path__ + "static/img/国旅感谢信.08f80946.jpg";